import { containsSome } from '@grapes-agency/universal'

import { ROLES, ROLE_IDS } from 'common/constants'

export const hasRoleTRB = containsSome([ROLES[ROLE_IDS.TRB]])
export const hasRoleLawyer = containsSome([ROLES[ROLE_IDS.Lawyer]])
export const hasRoleChannel = containsSome([ROLES[ROLE_IDS.Channel]])
